import Http from "../../http/client";
import { RequestQueryBuilder } from "@nestjsx/crud-request";

export default async ({city, category, level, status, active, driverId, userId, fields, perPage, page, isPhoneShared, isFake}) => {
  const qb = RequestQueryBuilder.create();

  if(city) { qb.setFilter({ field: "city.id", operator: "$eq", value: city }) }
  if(driverId) { qb.setFilter({ field: "driver.id", operator: "$eq", value: driverId }) }
  if(userId) { qb.setFilter({ field: "u.id", operator: "$eq", value: userId }) }
  if(category) { qb.setFilter({ field: "category.id", operator: "$eq", value: category }) }
  if(level) { qb.setFilter({ field: "level.id", operator: "$eq", value: level }) }
  if(status) { qb.setFilter({ field: "status", operator: "$eq", value: status }) }
  if(active) { qb.setFilter({ field: "active", operator: "$eq", value: active }) }
  if(isPhoneShared) { qb.setFilter({ field: "isPhoneShared", operator: "$eq", value: true }) }
  if(isFake) { qb.setFilter({ field: "isFake", operator: "$eq", value: true }) }

  qb.sortBy({field: 'createdAt', order: "DESC"});

  qb.setPage(page);
  qb.setLimit(perPage);
  qb.setOffset(perPage * page);
  qb.setJoin({field: 'user', select: ['id', 'name', 'surname']});
  qb.setJoin({field: 'driver', select: ['id', 'name', 'surname']});
  qb.setJoin({field: 'category', select: ['name']});
  qb.setJoin({field: 'level', select: ['name']});
  qb.setJoin({field: 'payment', select: ['price', 'paymentType']});
  qb.setJoin({field: 'city', select: ['name']});
  qb.select(fields);

  const response = await Http.get('admin/trips', {
    params: qb.queryObject
  });

  return response.data;
}
